import { P2GBox } from '@parcel2go/core-ui';
import { P2GCheckBoxLegacy } from '@parcel2go/core-ui';
import { P2GLink } from '@parcel2go/core-ui';
import { P2GLinkGroup } from '@parcel2go/core-ui';

import IncExc from './IncExc';
import { FilterOptionsGridProps } from './FilterOptionsGrid';
import { P2GGrid } from '@parcel2go/core-ui';
import P2GConditionalImage from '../../P2GConditionalImage';
import IndexFade from './IndexFade';

const FilterOptionsGridIconCheckbox = (props: FilterOptionsGridProps) => (
  <IncExc
    mode={props.mode}
    setMode={props.setMode}
    ctr={
      <P2GLinkGroup
        links={[
          props.selected.length > 0 && (
            <P2GLink variant="body2" onClick={props.clearSelected}>
              Clear
            </P2GLink>
          ),
          props.selected.length < props.filterItem.options.length && (
            <P2GLink variant="body2" onClick={props.selectAll}>
              Select All
            </P2GLink>
          )
        ]}
      />
    }
  >
    <P2GGrid container spacing={1}>
      {props.filterItem.options.map((o, i) => (
        <P2GGrid item key={o.value}>
          <IndexFade index={i}>
            <P2GBox bordered pl={1} pr={1} mb={1}>
              <P2GGrid container alignItems="center" alignContent="center">
                <P2GGrid item flexShrink={1}>
                  <P2GCheckBoxLegacy
                    key={o.value}
                    checked={props.isSelected(o.value)}
                    onChange={() => props.toggleSelected(o.value)}
                    id={o.text}
                    label={o.text}
                    labelPlacement="end"
                    variant="primary"
                    error={false}
                  />
                </P2GGrid>
                <P2GGrid item flexShrink={1}>
                  <P2GConditionalImage style={{ height: '25px' }} alt={o.text} src={o.image} />
                </P2GGrid>
              </P2GGrid>
            </P2GBox>
          </IndexFade>
        </P2GGrid>
      ))}
    </P2GGrid>
  </IncExc>
);

export default FilterOptionsGridIconCheckbox;
